import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { AppSidebar } from '@/components/layout/app-sidebar';
import { MobileNavbar } from './components/layout/mobile-navbar';

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <>
      <MobileNavbar />
      <div className="max-w-[1920px] mx-auto">
        <SidebarProvider>
          <AppSidebar />
          <SidebarInset>
            <div className="relative pt-6 pb-4 px-4 md:px-8 md:pb-12">{children}</div>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </>
  );
}
